// @noflow
import type {State} from 'src/reducers';
import type {WhatsAppDetails, GraphDetails} from 'src/types/chatbot';
import {createSelector} from 'reselect';

import _merge from 'lodash/merge';
import _values from 'lodash/values';
import keyBy from 'lodash/keyBy';


const handleData = (graphInfo, visits) => {
  const keyByVisits = keyBy(visits, 'node_id');
  graphInfo.forEach((dt, index) => {
    if (keyByVisits[dt.node_id]) {
      graphInfo[index].visits = keyByVisits[dt.node_id].visits;
    }
  });

  return graphInfo;
};

export const getSankeyGraph = (state: State): ?string =>
  state.chatbot?.sankeyGraph;

export const getSankeyGraphVisits = (state: State): ?string =>
  state.chatbot?.sankeyGraphVisits;

export const getPeopleEngagedList = (state: State): ?string =>
  state.chatbot?.peopleEngaged;

export const isPeopleEngagedDataLoading = (state: State): ?string =>
  state.chatbot?.isPeopleEngagedLoading;

export const isSankeyGraphDataLoading = (state: State): ?boolean =>
  state.chatbot?.isSankeyGraphLoading;

export const selectQuestionSimilarity = (state: State): ?boolean =>
  state.chatbot?.questionSimilarity;

export const selectPresetQuestions = (state: State): ?boolean =>
  state.chatbot?.presetQuestions;

export const selectSankeyData: (
  State,
  string,
  // $FlowFixMe[value-as-type]
) => SankeyGraphInfo = createSelector(
  getSankeyGraph,
  getSankeyGraphVisits,
  (_state, id) => id,
  (graphInfo, visits) => {
    if (graphInfo?.length > 0 && visits?.length > 0) {
      try {
        return handleData(graphInfo, visits);
      } catch (error) {
        return _values(
          _merge(keyBy(graphInfo, 'node_id'), keyBy(visits, 'node_id')),
        );
      }
    }
    return [];
  },
);

export const selectPeopleEngaged = createSelector(
  getPeopleEngagedList,
  (peopleEngagedList) => peopleEngagedList,
);

export const selectIsPeopleEngagedDataLoading = createSelector(
  isPeopleEngagedDataLoading,
  (isLoading) => isLoading,
);

export const selectIsSankeyGraphDataLoading = createSelector(
  isSankeyGraphDataLoading,
  (isLoading) => isLoading,
);

export const getWhatsappDetails = createSelector(
  (state: State): ?WhatsAppDetails => state.chatbot.whatsappDetails,
  (whatsappDetails) => whatsappDetails,
);

export const getFlowDetails = createSelector(
  (state: State): ?GraphDetails => state.chatbot.flowDetails,
  (flowDetails) => flowDetails,
);
